<template>
  <!-- Navbar -->
  <TeoNavbar
    :online="online"
    :loggedin="loggedIn"
    @info="(v) => (showConnect = v)"
  />

  <!-- Content component -->
  <TeoConnect v-show="showConnect" @online="(v) => (online = v)" />

  <!-- Body -->
  <div class="container">
    <!-- 
      * SignIn component.
      * Provides Sign In/Sign Up/Password Reset forms
      * Innput properties:
      * - showButton: show Logout button
      * - needLogout: do logout
    -->
    <SignIn
      :showButton="showButton"
      :needLogout="needLogout"
      @ready="(v) => (signedIn = v)"
      @loggedin="(v) => (loggedIn = v)"
    />

    <!-- Page component -->
    <component
      v-if="signedIn"
      :is="currentView"
      :signedIn="signedIn && loggedIn"
      @showButton="(v) => (showButton = v)"
      @needLogout="(v) => (needLogout = v)"
    />
  </div>

  <!-- Footer -->
  <TeoFooter />
</template>

<script>
import TeoNavbar from "./components/TeoNavbar.vue";
import TeoConnect from "./components/TeoConnect.vue";
import TeoFooter from "./components/TeoFooter.vue";
import PageHome from "./components/pages/PageHome.vue";
import PageInfo from "./components/pages/PageInfo.vue";
import PageApps from "./components/pages/PageApps.vue";
import PageCrypt from "./components/pages/PageCrypt.vue";
import PageCommands from "./components/pages/PageCommands.vue";
import PageReciep from "./components/pages/PageReciep.vue";
import PageLogin from "./components/pages/PageLogin.vue";
import PageGenerateRecipe from "./components/pages/PageGenerateRecipe.vue";
import PageCookingMode from "./components/pages/PageCookingMode.vue";
import PageProfile from "./components/pages/PageProfile.vue";
import PageRecieps from "./components/pages/PageRecieps.vue";
import ImageGenerator from "./components/ImageGenerator.vue";
import SignIn from "./components/SignIn.vue";
import UsersRecipes from "./components/pages/UsersRecipes.vue";
import PageCookingList from "./components/pages/PageCookingList.vue";
import PageAdminIngredients from "./components/pages/PageAdminIngredients.vue";
import PageAuthor from "./components/pages/PageAuthor.vue";
import PageSubscription from "./components/pages/PageSubscription.vue";
import PageArticle from "./components/pages/PageArticle.vue";

const routes = {
  "/": { page: PageHome, name: "Home" },
  "/apps": { page: PageApps, name: "Applications" },
  "/about": { page: PageInfo, name: "About" },
  "/crypt": { page: PageCrypt, name: "Crypt" },
  "/login": { page: PageLogin, name: "Login" },
  "/commands": { page: PageCommands, name: "Commands" },
  "/recipes": { page: PageRecieps, name: "Recipes" },
  "/recipes/:id": { page: PageReciep, name: "Recipe Detail" },
  "/generate-recipe": { page: PageGenerateRecipe, name: "Generate Recipe" },
  "/profile": { page: PageProfile, name: "User Profile" },
  "/cooking-mode": { page: PageCookingMode, name: "Cooking Mode" },
  "/auth": { page: SignIn, name: "Authentication" },
  "/cooking-list": { page: PageCookingList, name: "Cooking List" },
  "/ingredients": { page: PageAdminIngredients, name: "Ingredients" },
  "/image-generator": { page: ImageGenerator, name: "Image Generator" },
  "/my-recipes": { page: UsersRecipes, name: "My Recipes" },
  "/author/:authorName": { page: PageAuthor, name: "Author Recipes" },
  "/subscription": { page: PageSubscription, name: "Subscription" },
  "/article/:id": { page: PageArticle, name: "Article" },
};

export default {
  name: "App",
  components: {
    TeoNavbar,
    TeoConnect,
    TeoFooter,
    SignIn,
  },
  data() {
    return {
      online: false,
      signedIn: false,
      loggedIn: false,
      needLogout: false,
      showConnect: true,
      showButton: false,
      currentPath: window.location.hash,
    };
  },

  computed: {
    /**
     * Finds the matching route from the routes object
     * and returns the corresponding page component.
     *
     * If no matching route is found, returns the PageHome component
     * with the name "Home".
     *
     * @returns {Object} The page component
     */
    currentView() {
      // Get the path from the hash, remove the leading '#'
      let path = this.currentPath.slice(1);

      // Find the matching route in the routes object
      let route = null;

      for (const routePath in routes) {
        // Convert route path with parameters to a regex
        const regexPath = routePath.replace(
          /:([a-zA-Z0-9_]+)/g,
          "(?<$1>[^/]+)"
        );
        const regex = new RegExp(`^${regexPath}$`);
        const match = path.match(regex);

        // If a match is found, set the route to the matching route
        if (match) {
          route = routes[routePath];
          break; // Found a match, no need to continue
        }
      }

      // If no matching route is found, return the PageHome component
      if (!route) {
        route = {
          page: PageHome,
          name: "Home",
        };
      }

      // Set the document title to the route name
      document.title = route.name;
      return route.page;
    },
  },

  mounted() {
    let that = this;

    window.addEventListener("hashchange", () => {
      that.currentPath = window.location.hash;
    });
  },
};
</script>

<style>
/* Syles for whole application */

.container {
  max-width: 820px !important;
}

h1 {
  margin-top: 12px !important;
}

/* link color */
body a {
  color: #42b983;
}

/* hr color */
body hr {
  color: gray;
}

/* description class style */
.description {
  font-size: small;
  margin-bottom: 10px;
}

hr.norm {
  margin-top: 20px;
}
</style>
